import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { store } from '@/store';
import { createAppTheme } from '@/styles/theme';
import { useTheme, useAppInit } from '@/hooks';
import { GlobalLoader, AppRoutes } from '@/components';
import { COLORS } from '@/constants/colors';

const AppContent: React.FC = () => {
  const { mode, colors } = useTheme();
  const { isInitialized } = useAppInit();
  const theme = createAppTheme(mode, colors);

  // Show loading screen while initializing authentication
  if (!isInitialized) {
    return (
      <HelmetProvider>
        <ThemeProvider theme={theme}>

          <CssBaseline />
          <GlobalLoader />
        </ThemeProvider>
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalLoader />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: mode === 'dark' ? COLORS.NEUTRAL.GREY_800 : COLORS.NEUTRAL.WHITE,
              color: mode === 'dark' ? COLORS.NEUTRAL.WHITE : COLORS.NEUTRAL.GREY_800,
            },
          }}
        />
        <Router>
         <FloatingWhatsApp accountName={"HRTalky"} phoneNumber={'+919884457471'} placeholder={"Ask your query"}  notification={true} statusMessage={'Online'} chatMessage={"Welcome to HRTalky! India’s HR Hub"} darkMode={mode === 'dark'} avatar={"/logotk.jpeg" }/>

          <AppRoutes />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
};

export default App;
